import React, { useEffect, useState } from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import DesignBoxNavigationCrumb from "../Reusables/DesignBoxNavigationCrumb";
import "../../fonts/Futura-PT-Book.ttf";
import design_icon from "../../assets/images/icons/design_icon.svg";
import DesignBoxTabBar from "../Reusables/DesignBoxTabBar";
import DesignBoxAllItems from "./DesignBoxAllItems";
import Loading from "../Loading/Loading";
import styles from "./DesignBox.module.css";
import useAxios from "../Hooks/useAxios";
import LinkSocialAppIcon from "./LinkSocialAppIcon";
import LinkToTopPageBtn from "../Reusables/LinkToTopPageBtn";
import { useLocation } from "react-router-dom";
// import axios from "axios";
const DesignBox = () => {
  const axios = useAxios();
  const backend_base = process.env.REACT_APP_API_BASE_URL;
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const activeTab = queryParams?.get("activeTab"); //navigate("/design-box?activeTab=2"); as an example
  const [showWarningIconOnUneditedTab, setshowWarningIconOnUneditedTab] =
    useState(false);
  const [showWarningIconOnConfirmedTab, setshowWarningIconOnConfirmedTab] =
    useState(false);
  const [loading, setLoading] = useState(false);
  const [tabActive, setTabActive] = useState(
    activeTab ? parseInt(activeTab) : 1
  );
  const [editedProducts, setEditedProducts] = useState([]);
  const [uneditedProducts, setUneditedProducts] = useState([]);
  const changingTab = (id) => {
    setTabActive(id);
  };
  useEffect(() => {
    setLoading(true);
    axios
      .get(backend_base + "/design/")
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("Success Getting Design Box Items");
          console.log(res.data, "from here");
          setEditedProducts(res.data.edited_products_address);
          setUneditedProducts(res.data.unedited_products_address);
          setLoading(false);
        } else {
          setLoading(false);
          alert("Failed to design box data");
          console.log("Failed to design box data");
        }
      })
      .catch((e) => {
        setLoading(false);
        alert(e.message);
        console.log(e);
      });
  }, []);

  return (
    <>
      <Header />
      <div className={styles.design_box_main_div}>
        {/* <DesignBoxNavigationCrumb
          active={3}
          active5={"#E3E383"}
          inactive5={"#F7F7DE"}
        /> */}
        <div className={styles.design_box_header_main_div}>
          <div className={styles.design_box_header_top}>
            <img src={design_icon} alt="design_icon"></img>
            <div className={styles.design_box_header_top_text}>Design Box</div>
          </div>
          <div className={styles.design_box_header_hr} />
          <div className={styles.design_box_header_bottom_text}>
            購入アイテム一覧
          </div>
        </div>
        <div className={styles.design_box_tab_section}>
          <DesignBoxTabBar
            active={tabActive}
            setActive={changingTab}
            showWarningIconOnConfirmedTab={showWarningIconOnConfirmedTab}
            showWarningIconOnUneditedTab={showWarningIconOnUneditedTab}
          />
          {loading && <Loading style={{ margin: "100px auto" }} />}
          {!loading && (
            <DesignBoxAllItems
              active={tabActive}
              edited_products={editedProducts}
              unedited_products={uneditedProducts}
              setshowWarningIconOnConfirmedTab={
                setshowWarningIconOnConfirmedTab
              }
              setshowWarningIconOnUneditedTab={setshowWarningIconOnUneditedTab}
            />
          )}
        </div>
        <LinkToTopPageBtn />
        <div className={styles.dbx_bottom_line_main_wrapper}>
          <div className={styles.dbx_bottom_line_main}>
            <div className={styles.dbx_bottom_line_main_header01}>
              お問い合わせ
            </div>
            <div className={styles.dbx_bottom_line_main_header02}>
              商品に関するお問い合わせや編集のご質問は、Acestudio Official
              LINEへお願いいたします。
            </div>
            <LinkSocialAppIcon />
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default DesignBox;
